module.exports = __webpack_public_path__ + "img/Hawaiian Poke-Chicken.b96c219a.jpg";